<template>
	<div data-tour-scope="fattureincloud-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> Fattureincloud</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="dataordine" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatejs" v-on="on" dense clearable @click:clear="cleardate" label="Data ordine" outlined hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.created_at" @change="dataordine = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.invoice_type" :items="invoice_types" multiple dense label="Status Fatturazione" outlined hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.platform" :items="platform" multiple dense label="Platform" outlined hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.payments" :items="payments" multiple dense label="Payment" outlined hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.status" :items="status" multiple dense label="Status" outlined hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.color" :items="selectColor" label="Tags" multiple clearable dense prepend-inner-icon="mdi-tag" outlined hide-details></v-select>
								</v-col>
							</v-row>
						</v-col>
						<!--						<v-card v-if="selectedchecbox.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selectedchecbox.length }}
									<span v-if="selectedchecbox.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="eliminaCorrispettivo(null)" v-if="InvoiceItem && TypeInvoice === 'sales_receipt' && selectedchecbox.length === 1 && fattureincloud"> Elimina Corrispettivo </v-tab>
								<v-tab @click="rimborsaCorrispettivo(null)" v-if="InvoiceItem && TypeInvoice === 'sales_receipt' && selectedchecbox.length === 1 && fattureincloud"> Rimborsa Corrispettivo </v-tab>
								<v-tab @click="eliminaFattura(null)" v-if="InvoiceItem && TypeInvoice === 'Fattura' && selectedchecbox.length === 1 && fattureincloud"> Elimina Fattura </v-tab>
								<v-tab @click="creaCorrispettivo(null)" v-if="!InvoiceItem && selectedchecbox.length === 1 && fattureincloud"> Crea Corrispettivo </v-tab>
								<v-tab @click="creaFattura(null)" v-if="!InvoiceItem && selectedchecbox.length === 1 && fattureincloud"> Crea Fattura </v-tab>
							</v-tabs>
						</v-card>-->

						<v-data-table
							data-tour="table"
							v-model="selectedall"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							must-sort
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:mobile="isMobile"
							@input="toggle"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="fic-list-cards">
									<tr v-for="item in righeCard(items)" :key="item._id">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<!-- il bordo sinistro riprende il colore di stato che su desktop colora la riga -->
											<key-value-card
												:fields="campiCard(item)"
												:style="'border-left: 4px solid ' + getStatusColor(item.StatusOrder) + ' !important;'"
												:data-tour="!item.Invoice || !item.Invoice?.id ? 'row-no-document' : 'row-document'"
											>
												<template v-slot:title>
													<span class="primary--text" style="cursor: pointer" data-tour="order" @click="editItem(item)">#{{ item.OrderID }}</span>
													<span v-if="buyerName(item)" class="font-weight-regular"> · {{ buyerName(item) }}</span>
												</template>
												<template v-slot:actions>
													<v-menu data-tour="tag" offset-y :close-on-content-click="closeOnContentClick">
														<template v-slot:activator="{ on }">
															<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on">
																<v-icon>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item v-for="colore in selectColor" :key="colore">
																<v-btn @click="changeStatus(item, colore)" elevation="0" icon :color="colore"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra dettagli'" @click="extension(item._id)">
														<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu left offset-y eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon> mdi-dots-vertical </v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.Invoice && item.Invoice.type === 'sales_receipt'" @click="chiediConferma('Eliminare il corrispettivo su Fatture in Cloud?', () => eliminaCorrispettivo(item))">
																<v-list-item-title class="size9">Elimina Corrispettivo</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.Invoice && item.Invoice.type === 'sales_receipt' && item.Invoice.amount_net >= 0" @click="chiediConferma('Emettere il rimborso del corrispettivo su Fatture in Cloud?', () => rimborsaCorrispettivo(item))">
																<v-list-item-title class="size9">Rimborsa Corrispettivo</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.Invoice && item.Invoice.type === 'invoice'" @click="chiediConferma('Eliminare il documento su Fatture in Cloud?', () => eliminaInvoice(item))">
																<v-list-item-title class="size9">Elimina Fattura</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.Invoice && item.Invoice.type === 'invoice'" @click="chiediConferma('Creare la nota di credito su Fatture in Cloud?', () => creaNotaDiCredito(item))">
																<v-list-item-title class="size9">Crea nota di credito</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.Invoice && item.Invoice.type === 'credit_note'" @click="chiediConferma('Eliminare il documento su Fatture in Cloud?', () => eliminaInvoice(item))">
																<v-list-item-title class="size9">Elimina Nota di credito</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="!item.Invoice || !item.Invoice?.id" data-tour="create-receipt" @click="creaCorrispettivo(item)">
																<v-list-item-title class="size9">Crea Corrispettivo</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="!item.Invoice || !item.Invoice?.id" data-tour="create-invoice" @click="creaFattura(item)">
																<v-list-item-title class="size9">Crea Fattura</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center flex-wrap mb-2">
														<v-avatar size="28px" tile class="mr-2">
															<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
														</v-avatar>
														<v-avatar size="16px" tile class="mr-2" v-if="item.ShippingAddress && item.ShippingAddress.Country">
															<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress.Country" />
														</v-avatar>
														<v-avatar size="24px" tile class="mr-2">
															<img
																:src="item.Invoice && item.Invoice?.id ? require(`@/assets/images/fattureincloud_active.svg`) : require(`@/assets/images/fattureincloud.svg`)"
																alt="Fattureincloud"
															/>
														</v-avatar>
														<v-avatar v-if="item.printed" size="22px" tile class="mr-2" style="cursor: pointer" @click="openDialogPrint(item)">
															<img src="@/assets/images/printer.svg" alt="Stampa effettuata" />
														</v-avatar>
														<v-avatar v-if="item.id_packing_list && item.id_packing_list.length > 0" size="22px" tile class="mr-2" style="cursor: pointer" @click="packingListItem(item)">
															<img
																:src="item.id_packing_list[0].status === 'completed' ? require('@/assets/images/packing_list_completed.svg') : require('@/assets/images/packing_list.svg')"
																alt="Packing List"
															/>
														</v-avatar>
														<v-avatar v-if="_.trim(item.Message) !== ''" size="22px" tile class="mr-2">
															<img :src="require('@/assets/images/mail.svg')" alt="Ordine contiene delle note" />
														</v-avatar>
														<v-avatar v-if="item.ShippedTime" size="22px" tile class="mr-2">
															<img :src="require('@/assets/images/box_ship.svg')" alt="Spedito" />
														</v-avatar>
														<v-avatar v-if="item.requestInvoice" size="22px" tile class="mr-2">
															<img :src="require('@/assets/images/invoice.svg')" alt="Richiesta fattura" />
														</v-avatar>
														<v-avatar v-if="item.codProcessed" size="24px" tile class="mr-2">
															<img :src="require('@/assets/images/Cod.svg')" alt="Contrassegno Incassato" />
														</v-avatar>
														<v-spacer></v-spacer>
														<v-btn v-if="item?.Invoice?.url" :href="item.Invoice.url" target="_blank" small text color="primary" data-tour="document">
															<v-icon left small>mdi-file-pdf-box</v-icon>PDF
														</v-btn>
													</div>
													<div v-if="item.Buy || item.Refund" class="mb-1">
														<v-chip v-if="item.Buy" class="mr-2" color="success" outlined x-small>
															{{ (scorporoiva(item.Total, item.BuyVat) - item.Buy - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
														</v-chip>
														<v-chip v-if="item.Refund" color="error" outlined x-small>
															{{ (item.Total - item.Refund - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
														</v-chip>
													</div>
												</template>
												<template v-if="checkpresenza(item._id)">
													<template v-if="item.requestInvoice || item.Message || (item.Platform === 'Store' && !(item.buyer && item.buyer._id))">
														<div class="fic-section">Info utili</div>
														<div class="fic-line mb-3">
															<div v-if="item.requestInvoice" class="d-flex align-center">
																<v-icon small color="red" class="mr-2">mdi-file-document-alert</v-icon>
																<span class="font-weight-bold">Richiesta Fattura</span>
															</div>
															<div v-if="item.Message"><strong>Messaggio dal Cliente:</strong> {{ item.Message }}</div>
															<div v-if="item.Platform === 'Store' && !(item.buyer && item.buyer._id)">Ordine in modalità ospite</div>
														</div>
													</template>
													<div class="fic-section">Dati di spedizione</div>
													<div class="fic-line mb-3">
														<div v-for="riga in datiSpedizione(item)" :key="'s' + riga.label" class="fic-kv">
															<span>{{ riga.label }}</span>
															<span>
																{{ riga.value }}
																<v-btn x-small icon @click="copy(riga.copy)"><v-icon x-small>mdi-content-copy</v-icon></v-btn>
															</span>
														</div>
														<div v-if="!datiSpedizione(item).length" class="grey--text">Nessun dato</div>
													</div>
													<template v-if="item.requestInvoice">
														<div class="fic-section">Dati di fatturazione</div>
														<div class="fic-line mb-3">
															<div v-for="riga in datiFatturazione(item)" :key="'f' + riga.label" class="fic-kv">
																<span>{{ riga.label }}</span>
																<span>
																	{{ riga.value }}
																	<v-btn x-small icon @click="copy(riga.value)"><v-icon x-small>mdi-content-copy</v-icon></v-btn>
																</span>
															</div>
															<div v-if="!datiFatturazione(item).length" class="grey--text">Nessun dato</div>
														</div>
													</template>
													<div class="fic-section">Prodotti acquistati</div>
													<div v-for="(prod, index) in item.Items" :key="'p' + index" class="fic-line">
														<div class="font-weight-medium">{{ prod.Title || 'Prodotto' }}</div>
														<div class="fic-kv"><span>SKU</span><span>{{ prod.SKU || '-' }}</span></div>
														<div class="fic-kv"><span>ID</span><span>{{ prod.ItemID || '-' }}</span></div>
														<div class="fic-kv"><span>Quantità</span><span class="font-weight-bold">{{ prod.QuantityPurchased }}</span></div>
														<div class="fic-kv"><span>Prezzo</span><span>€ {{ prod.TransactionPrice }}</span></div>
													</div>
													<div v-if="!(item.Items || []).length" class="grey--text">Nessun prodotto</div>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!righeCard(items).length">
										<td :colspan="headers.length + 1" class="text-center grey--text py-6">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr v-if="item.StatusOrder && item.StatusOrder._id" :style="'background:' + getStatusColor(item.StatusOrder) + ';'" :key="`${item._id}${_.random(1, 10000)}`" :data-tour="!item.Invoice || !item.Invoice?.id ? 'row-no-document' : 'row-document'">
											<!--											<td>
												<v-checkbox class="mt-0 mr-0 pr-0" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
											</td>-->
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
												<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
												<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="item.Invoice && item.Invoice.type === 'sales_receipt'" @click="chiediConferma('Eliminare il corrispettivo su Fatture in Cloud?', () => eliminaCorrispettivo(item))">
															<v-list-item-title class="size9">Elimina Corrispettivo</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="item.Invoice && item.Invoice.type === 'sales_receipt' && item.Invoice.amount_net >= 0">
															<v-list-item-title @click="chiediConferma('Emettere il rimborso del corrispettivo su Fatture in Cloud?', () => rimborsaCorrispettivo(item))" class="size9">Rimborsa Corrispettivo</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="item.Invoice && item.Invoice.type === 'invoice'" @click="chiediConferma('Eliminare il documento su Fatture in Cloud?', () => eliminaInvoice(item))">
															<v-list-item-title class="size9">Elimina Fattura</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="item.Invoice && item.Invoice.type === 'invoice'" @click="chiediConferma('Creare la nota di credito su Fatture in Cloud?', () => creaNotaDiCredito(item))">
															<v-list-item-title class="size9">Crea nota di credito</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="item.Invoice && item.Invoice.type === 'credit_note'" @click="chiediConferma('Eliminare il documento su Fatture in Cloud?', () => eliminaInvoice(item))">
															<v-list-item-title class="size9">Elimina Nota di credito</v-list-item-title>
														</v-list-item>
												<v-list-item link v-if="!item.Invoice || !item.Invoice?.id" data-tour="create-receipt" @click="creaCorrispettivo(item)">
															<v-list-item-title class="size9">Crea Corrispettivo</v-list-item-title>
														</v-list-item>
												<v-list-item link v-if="!item.Invoice || !item.Invoice?.id" data-tour="create-invoice" @click="creaFattura(item)">
															<v-list-item-title class="size9">Crea Fattura</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td>{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td class="pr-1 mr-1" style="white-space: nowrap">
												<div style="background: #ffffffcf; border-radius: 5px; padding: 3px">
													<v-avatar size="32px" tile>
														<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
													</v-avatar>
													<v-avatar size="16px" tile style="margin-left: 5px" v-if="item.ShippingAddress && item.ShippingAddress.Country">
														<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress" />
													</v-avatar>
												</div>
											</td>
											<td class="pl-0 ml-0" style="white-space: nowrap">
												<div
													:style="
														item.printed || item.id_packing_list.length > 0 || _.trim(item.Message) !== '' || item.ShippedTime || item.codProcessed || item.requestInvoice
															? 'background: #ffffffcf;border-radius: 5px;padding: 3px;'
															: ''
													"
												>
													<!--												<template v-if="item.worker">-->
													<!--													<v-chip color="success" label small style="min-width: 120px">-->
													<!--														<v-icon left small>mdi-account-circle-outline</v-icon>-->
													<!--														{{ item.worker.name }}-->
													<!--													</v-chip>-->
													<!--												</template>-->
													<!--												<template v-else>-->
													<!--													<v-chip color="white" label small @click="openDialogPrint(item)" style="min-width: 20px">-->
													<!--														<v-icon left small color="red">mdi-progress-alert</v-icon>-->
													<!--														Non assegnato-->
													<!--													</v-chip>-->
													<!--												</template>-->
													<!-- Icona stampa -->
													<template v-if="item.printed">
														<v-avatar size="26px" tile class="mr-2" style="cursor: pointer" @click="openDialogPrint(item)">
															<img src="@/assets/images/printer.svg" alt="Stampa effettuata" />
														</v-avatar>
													</template>

													<!-- Icona packing list -->
													<template v-if="item.id_packing_list.length > 0">
														<v-avatar size="26px" tile class="mr-2" style="cursor: pointer" @click="packingListItem(item)">
															<img
																:src="item.id_packing_list[0].status === 'completed' ? require('@/assets/images/packing_list_completed.svg') : require('@/assets/images/packing_list.svg')"
																alt="Packing List"
															/>
														</v-avatar>
													</template>

													<!-- Icona nota / messaggio -->
													<template v-if="_.trim(item.Message) !== ''">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/mail.svg')" alt="Ordine contiene delle note" />
														</v-avatar>
													</template>

													<!-- Icona spedizione -->
													<template v-if="item.ShippedTime">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/box_ship.svg')" alt="Spedito" />
														</v-avatar>
													</template>

													<!-- Icona Invoice -->
													<template v-if="item.requestInvoice">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/invoice.svg')" alt="Richiesta fattura" />
														</v-avatar>
													</template>

													<!-- Icona Invoice -->
													<template v-if="item.codProcessed">
														<v-avatar size="30px" tile class="mr-2">
															<img :src="require('@/assets/images/Cod.svg')" alt="Contrassegno Incassato" />
														</v-avatar>
													</template>
												</div>
											</td>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
										<v-btn small icon data-tour="expand" @click="extension(item._id)">
													<v-icon v-if="!checkpresenza(item._id)">mdi-plus</v-icon>
													<v-icon v-else>mdi-minus</v-icon>
												</v-btn>
											</td>
											<td class="order-id-cell">
												<div class="order-id">
													<span v-html="convertSearch(item.OrderID)"></span>
													<v-btn icon x-small class="ml-1" data-tour="order" @click="editItem(item)" :color="isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) ? 'white' : ''">
														<v-icon small>mdi-magnify</v-icon>
													</v-btn>
												</div>
												<div v-if="item?.Coupon?.code"><span class="order-label">Coupon</span> {{ item.Coupon.code }}</div>
											</td>
											<td class="order-cell">
												<div v-if="buyerName(item)" class="order-buyer" v-html="convertSearch(buyerName(item))"></div>
												<div v-if="item?.Checkout?.StatusPayment?.value"><span class="order-label">Pagamento</span> {{ item.Checkout.StatusPayment.value }}</div>
												<div v-if="item.OrderStatus"><span class="order-label">Marketplace</span> {{ item.OrderStatus }}</div>
											</td>
											<td>
												<span v-if="item.StatusOrder && item.StatusOrder.value">{{ item.StatusOrder.value }}</span>
											</td>
											<!--<td>{{ (item.preparation_date != undefined || item.preparation_date != null) ? new Date(item.preparation_date).toLocaleDateString() : 'n.d.' }}</td>-->
											<td class="text-right">
												<v-chip v-if="item.Buy" class="ma-2" color="success" outlined x-small>
													{{ (scorporoiva(item.Total, item.BuyVat) - item.Buy - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
												</v-chip>
												<v-chip v-if="item.Refund" class="ma-2" color="error" outlined x-small>
													{{ (item.Total - item.Refund - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
												</v-chip>
												{{ item.Total }} {{ item.Currency }}
											</td>
											<td class="text-right">{{ item.Refund }}</td>
									<td style="" data-tour="document">
												{{ item?.Invoice?.id }}

												<span v-if="item?.Invoice?.url">
													<v-btn :href="item?.Invoice?.url" target="_blank" text> <v-icon>mdi-file-pdf-box </v-icon> </v-btn>
												</span>
											</td>
											<td>
												<div v-if="item.Invoice && item.Invoice?.id">
													<v-avatar size="32px" tile>
														<img :src="require(`@/assets/images/fattureincloud_active.svg`)" alt="Fattureincloud" />
													</v-avatar>
												</div>
												<div v-else>
													<v-avatar size="32px" tile>
														<img :src="require(`@/assets/images/fattureincloud.svg`)" alt="Fattureincloud" />
													</v-avatar>
												</div>
												<v-avatar v-if="_.trim(item.Message) !== ''" size="32px" tile>
													<img :src="require(`@/assets/images/mail.svg`)" alt="Message" />
												</v-avatar>
											</td>

											<td>
											<v-menu
												data-tour="tag"
													:disabled="disabled"
													:absolute="absolute"
													:open-on-hover="openOnHover"
													:close-on-click="closeOnClick"
													:close-on-content-click="closeOnContentClick"
													:offset-x="offsetX"
													:offset-y="offsetY"
												>
													<template v-slot:activator="{ on }">
														<v-btn icon small elevation="0" :color="item.Color || 'grey'" v-on="on">
															<v-icon>mdi-tag</v-icon>
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'red')" elevation="0" icon color="red"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'pink')" elevation="0" icon color="pink"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'purple')" elevation="0" icon color="purple"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'indigo')" elevation="0" icon color="indigo"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'blue')" elevation="0" icon color="blue"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'green')" elevation="0" icon color="green"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'yellow')" elevation="0" icon color="yellow"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'orange')" elevation="0" icon color="orange"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'grey')" elevation="0" icon color="grey"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
										</tr>
										<template v-if="checkpresenza(item._id)">
											<tr>
												<td :colspan="headers.length + 1" class="pa-0">
													<v-sheet class="ma-2 pa-2" color="#f5f5f5" rounded>
														<template v-if="item.requestInvoice || item.Message || (item.Platform === 'Store' && !item.buyer._id)">
															<h4 class="mb-2">💼 Info Utili</h4>
															<!-- 💼 Richiesta Fattura e Messaggio -->
															<div class="mb-4 d-flex flex-wrap white pa-2">
																<div v-if="item.requestInvoice" class="d-flex align-center">
																	<v-icon color="red" class="mr-2">mdi-file-document-alert</v-icon>
																	<span class="font-weight-bold text-danger">Richiesta Fattura</span>
																</div>
																<div v-if="item.Message" class="d-flex align-center ml-2">
																	<v-icon class="mr-2">mdi-note-text</v-icon>
																	<div><strong>Messaggio dal Cliente:</strong> {{ item.Message }}</div>
																</div>
																<div v-if="item.Platform === 'Store' && !item.buyer._id" class="d-flex align-center ml-2">
																	<v-icon class="mr-2">mdi-note-text</v-icon>
																	<div>Ordine in modalità ospite</div>
																</div>
															</div>
															<v-divider class="mb-4"></v-divider>
														</template>

														<!-- 📬 Indirizzo di Spedizione -->
														<div class="mb-3">
															<h4 class="mb-2">📦 Dati di Spedizione</h4>
															<div class="d-flex flex-wrap white pa-2">
																<div v-if="item.ShippingAddress && item.ShippingAddress.Name" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Nome:</strong> {{ item.ShippingAddress.Name }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Name)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress && item.ShippingAddress.Street1" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Indirizzo:</strong> {{ item.ShippingAddress.Street1 }} {{ item.ShippingAddress.Street2 }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Street1)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress && item.ShippingAddress.CityName" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Città:</strong> {{ item.ShippingAddress.CityName }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.CityName)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress && item.ShippingAddress.PostalCode" class="mr-6 d-flex align-center">
																	<strong class="mr-2">CAP:</strong> {{ item.ShippingAddress.PostalCode }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.PostalCode)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress && item.ShippingAddress.StateOrProvince" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Provincia:</strong> {{ item.ShippingAddress.StateOrProvince }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.StateOrProvince)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress && item.ShippingAddress.Country" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Nazione:</strong> {{ item.ShippingAddress.Country }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Country)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress && item.ShippingAddress.Phone" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Telefono:</strong> {{ item.ShippingAddress.Phone }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Phone)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
															</div>
														</div>

														<!-- 🧾 Indirizzo di Fatturazione -->
														<template v-if="item.requestInvoice">
															<v-divider class="mb-4"></v-divider>
															<div class="mb-3">
																<h4 class="mb-2">🧾 Dati di Fatturazione</h4>
																<div class="d-flex flex-wrap white pa-2">
																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Company" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Azienda:</strong> {{ item.InvoiceAddress.Company }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Company)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Address" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Indirizzo:</strong> {{ item.InvoiceAddress.Address }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Address)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.City" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Città:</strong> {{ item.InvoiceAddress.City }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.City)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Province" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Provincia:</strong> {{ item.InvoiceAddress.Province }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Province)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Country" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Nazione:</strong> {{ item.InvoiceAddress.Country }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Country)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Cap" class="mr-6 d-flex align-center">
																		<strong class="mr-2">CAP:</strong> {{ item.InvoiceAddress.Cap }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Cap)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Vat" class="mr-6 d-flex align-center">
																		<strong class="mr-2">P.IVA:</strong> {{ item.InvoiceAddress.Vat }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Vat)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Fiscalcode" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Cod. Fiscale:</strong> {{ item.InvoiceAddress.Fiscalcode }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Fiscalcode)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Sdi" class="mr-6 d-flex align-center">
																		<strong class="mr-2">SDI:</strong> {{ item.InvoiceAddress.Sdi }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Sdi)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress && item.InvoiceAddress.Pec" class="mr-6 d-flex align-center">
																		<strong class="mr-2">PEC:</strong> {{ item.InvoiceAddress.Pec }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Pec)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>
																</div>
															</div>
														</template>

														<!-- 🛒 Prodotti -->
														<v-divider class="mb-3"></v-divider>
														<div>
															<h4 class="mb-2">🛒 Prodotti acquistati</h4>
															<v-simple-table dense>
																<thead>
																	<tr>
																		<th>SKU</th>
																		<th>ID</th>
																		<th>Titolo</th>
																		<th>Quantità</th>
																		<th>Prezzo</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(prod, index) in item.Items" :key="index">
																		<td><span v-html="convertSearch(prod.SKU)"></span></td>
																		<td><span v-html="convertSearch(prod.ItemID)"></span></td>
																		<td><span v-html="convertSearch(prod.Title)"></span></td>
																		<td>{{ prod.QuantityPurchased }}</td>
																		<td>€ {{ prod.TransactionPrice }}</td>
																	</tr>
																</tbody>
															</v-simple-table>
														</div>
													</v-sheet>
												</td>
											</tr>
										</template>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<ImportShopify v-if="operation === 'ImportShopify'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></ImportShopify>
		</v-dialog>

		<!-- conferma delle azioni irreversibili su Fatture in Cloud -->
		<v-dialog v-model="conferma.aperta" max-width="380">
			<v-card>
				<v-card-title class="text-h6">Sei sicuro?</v-card-title>
				<v-card-text class="text-left">{{ conferma.testo }} L'operazione non si puo' annullare dal gestionale.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="conferma.aperta = false">Annulla</v-btn>
					<v-btn color="primary" depressed @click="eseguiConferma">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Seri sicuro?</v-card-title>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="secondary" @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOrderSupplier" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Seleziona una data</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<p>Indica una data entro cui tutti gli articoli presenti negli ordini selezionati saranno consegnati</p>
								<v-date-picker v-model="dateOrderSupplier" full-width locale="it-it" landscape :first-day-of-week="1"></v-date-picker>
							</v-col>
						</v-row>
					</v-container>
					<small>*Campi obbligatori</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialogOrderSupplier = false"> Annulla </v-btn>
					<v-btn color="blue darken-1" text @click="inviaOrdineFornitore"> Invia </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modalDownloadReview" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Inserisci il range di Ordini per il riepilogo</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<p>Indica in senso decrescente gli ID degli ordini da includere nel download del riepilogo.</p>
								<p v-if="idStart !== '' && idEnd !== ''">N.B. Sarà scaricato un riepilogo ordini con tutti gli ordini a partire da {{ idStart }} fino a {{ idEnd }} (questi inclusi)</p>
								<p v-if="errorDownloadReview !== ''" class="error--text">{{ errorDownloadReview }}</p>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field hide-details="auto" v-model="idStart" label="Ordine ID più recente" outlined clearable></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field hide-details="auto" v-model="idEnd" label="Ordine ID meno recente" outlined clearable></v-text-field>
							</v-col>
						</v-row>
					</v-container>
					<small>*Campi obbligatori</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="blue darken-1"
						text
						@click="
							modalDownloadReview = false;
							loadingDownload = false;
						"
					>
						Annulla
					</v-btn>
					<v-btn color="blue darken-1" text @click="downloadReviewById" :loading="loadingDownload"> Invia </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createFattureincloudTourSteps, stopFattureincloudTour } from './fattureincloud-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { openWithReturn } from '@/components/core/pageReturn';

import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100, 250, 500, 750, 1000];

const giorno = d => `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
function ultimoMese() {
	const oggi = new Date();
	const da = new Date();
	da.setMonth(da.getMonth() - 1);
	return [giorno(da), giorno(oggi)];
}
const ImportShopify = () => import('@/components/orders/ImportShopify.vue');

export default {
	name: 'Order',
	// pagina, righe, ordinamento, ricerca e filtri nell'URL: refresh e ritorno dalle pagine ripartono da li'
	mixins: [
		listRouteState({
			filters: { status: 'array', platform: 'array', created_at: 'array', payments: 'array', invoice_type: 'array', color: 'array' },
			perPageOptions: LIST_SIZE,
		}),
	],
	setup() {
		return { tour: useTour(createFattureincloudTourSteps(), { onStop: stopFattureincloudTour }) };
	},
	data() {
		return {
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,
			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					status: [],
					platform: [],
					// di default l'ultimo mese; se l'utente svuota le date l'URL lo ricorda (created_at=)
					created_at: ultimoMese(),
					preparation_date: [],
					payments: [],
					agents: [],
					invoice_type: [],
					color: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			conferma: { aperta: false, testo: '', azione: null },
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			listSize: LIST_SIZE,
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Data', value: 'created_at' },
				{ text: 'Piattaforma', value: 'Platform' },
				{ text: '', value: '' },
				{ text: '', value: '' },
				{ text: 'N. Ordine', value: 'OrderID' },
				{ text: 'Dettagli', value: 'buyer.name' },
				// {text: 'Nome',      value: 'buyer.name' },
				// {text: 'Cognome',   value: 'buyer.lastname' },
				/*{text: 'Email',     value: 'buyer.email' },*/
				{ text: 'Status', value: 'Status' },
				/*{text: 'Data preparazione',    value: 'preparation_date' },*/
				{ text: 'Totale', value: 'Total' },
				//{text: 'Agent',     value: 'agent' },
				//{text: 'Agent %',     value: 'agent.percentage' },
				{ text: 'Reso', value: 'Refund' },

				{ text: 'FattureInCloud', value: '' },
				{ text: 'Fatturato', value: 'Items' },
				// {text: 'Packaging',      value: 'Packaging' },
				{ text: '', value: '', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			menu: false,
			operation: '',
			invoice_types: [
				{ text: 'Ordini con corrispettivi', value: 'sales_receipt' },
				{ text: 'Ordini con fattura', value: 'invoice' },
				{ text: 'Ordini da sincronizzare', value: 'null' },
			],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	created() {},
	async mounted() {
		this.setDialog(false);
		this.setExistFilter(true);

		// stato della lista (pagina, filtri, ricerca) letto dall'URL in data()
		this.listLoad();

		this.linkdownload = `${this.getUrl}nocors/orders/download`;
		this.updateEnableAgents(false);
		let promises = [];
		promises.push(this.fetchSetting());
		promises.push(this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws', 'aliexpress', 'prestashop', 'woocommerce']));

		const result = await Promise.all(promises);
		const status = result[1];

		let magento = status.find(el => el.service === 'magento' && el.active === true);
		if (magento) {
			this.magento = magento.active;
			this.platform.push('Magento');
		}
		let shopify = status.find(el => el.service === 'shopify' && el.active === true);
		if (shopify) {
			this.shopify = shopify.active;
			this.platform.push('Shopify');
		}

		let aliexpress = status.find(el => el.service === 'aliexpress' && el.active === true);
		if (aliexpress) {
			this.aliexpress = aliexpress.active;
			this.platform.push('Aliexpress');
		}

		let prestashop = status.find(el => el.service === 'prestashop' && el.active === true);
		if (prestashop) {
			this.prestashop = prestashop.active;
			this.platform.push('Prestashop');
		}

		let woocommerce = status.find(el => el.service === 'woocommerce' && el.active === true);
		if (woocommerce) {
			this.woocommerce = woocommerce.active;
			this.platform.push('Woocommerce');
		}

		let fattureincloud = status.find(el => el.service === 'fattureInCloud' && el.active === true);
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
		let mws = status.find(el => el.service === 'mws' && el.active === true);
		if (mws) {
			this.platform.push('Amazon');
		}

		let ebay = status.find(el => el.service === 'ebay' && el.active === true);
		if (ebay) {
			this.platform.push('Ebay');
		}

		this.platform.push('Store');

		this.fetchStatusOrder().then(result => {
			let array_colors = this.getSettings?.status_order ? this.getSettings.status_order : [];
			_.forEach(result.data, el => {
				let textStatus = _.find(el.trans, { lang: this.getLanguage });
				let color = _.find(array_colors, { _id: el._id });
				this.status.push({
					text: textStatus.value,
					value: el._id,
					color: color ? color.color : '#FFFFFFF',
				});

				if (el._id === '60deb7436fee57191fa71150') {
					this.status_elaboration = {
						_id: el._id,
						value: textStatus.value,
					};
				}
			});

			this.fetchPaymentMethod().then(result => {
				_.forEach(result.data, el => {
					this.payments.push({ text: el.value, value: el._id });
				});
			});

			this.fetchAgentMethod().then(result => {
				_.forEach(result.data, el => {
					this.agents.push({ text: el.info.name + ' ' + el.info.lastname, value: el._id });
				});
			});

			this.fetchPackagings().then(result => {
				_.forEach(result.data, el => {
					this.packagings.push({ text: el.name, value: el });
				});
				//console.log(this.packagings)
			});
		});

		this.onUpdateOrdersList = () => this.getDataFromApi();
		this.$root.$on('updateOrdersList', this.onUpdateOrdersList);
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		selectedchecbox() {
			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.Status === 'In Preparazione') {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				this.checkInPreparazione = true;

				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item) {
						if (item.Status === 'In Preparazione') {
							this.checkInPreparazione = false;
							this.checkRollbackInPreparazione = true;
						}
					}
				});
			}
		},
	},
	components: {
		TourOverlay,
		ImportShopify,
		KeyValueCard,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'orders/getOrders',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'orders/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'orders/getSortBy',
			getSortDesc: 'orders/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getServices: 'services/getServices',
			getSettings: 'settings/getSetting',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			let filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
				}
				return d;
			});

			let sum;
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let total = 0;
				let refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}
			return filters;
		},
		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
		computedDatePrepjs() {
			let arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'orders/setOrders',
			setOrder: 'orders/setOrder',
			setIndex: 'orders/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
		}),
		...mapActions({
			fetchOrders: 'orders/asyncFetchData',
			fetchReports: 'orders/asyncFetchReportData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'orders/updateEnableAgents',
			getOrdersReview: 'orders/getOrdersReview',
			fetchPackagings: 'packagings/getListings',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',
		}),
		// come su desktop: solo gli ordini con uno stato valorizzato hanno la riga
		righeCard(items) {
			return (items || []).filter(item => item.StatusOrder && item.StatusOrder._id);
		},
		// coppie chiave/valore della card da telefono (i campi opzionali vuoti non vengono mostrati)
		campiCard(item) {
			const sempre = ['Data', 'Status', 'Totale', 'Documento'];
			return [
				{ label: 'Data', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '' },
				{ label: 'Status', value: item?.StatusOrder?.value, strong: true },
				{ label: 'Totale', value: [item.Total, item.Currency].filter(v => v !== undefined && v !== null).join(' '), strong: true },
				{ label: 'Reso', value: item.Refund },
				{ label: 'Documento', value: item?.Invoice?.id },
				{ label: 'Pagamento', value: item?.Checkout?.StatusPayment?.value },
				{ label: 'Marketplace', value: item.OrderStatus },
				{ label: 'Coupon', value: item?.Coupon?.code },
			].filter(campo => sempre.includes(campo.label) || (campo.value !== undefined && campo.value !== null && campo.value !== ''));
		},
		// righe dell'indirizzo di spedizione nel dettaglio della card (copy = valore copiato, come su desktop)
		datiSpedizione(item) {
			const a = item.ShippingAddress || {};
			return [
				{ label: 'Nome', value: a.Name, copy: a.Name },
				{ label: 'Indirizzo', value: [a.Street1, a.Street2].filter(Boolean).join(' '), copy: a.Street1 },
				{ label: 'Città', value: a.CityName, copy: a.CityName },
				{ label: 'CAP', value: a.PostalCode, copy: a.PostalCode },
				{ label: 'Provincia', value: a.StateOrProvince, copy: a.StateOrProvince },
				{ label: 'Nazione', value: a.Country, copy: a.Country },
				{ label: 'Telefono', value: a.Phone, copy: a.Phone },
			].filter(riga => riga.copy);
		},
		datiFatturazione(item) {
			const a = item.InvoiceAddress || {};
			return [
				{ label: 'Azienda', value: a.Company },
				{ label: 'Indirizzo', value: a.Address },
				{ label: 'Città', value: a.City },
				{ label: 'Provincia', value: a.Province },
				{ label: 'Nazione', value: a.Country },
				{ label: 'CAP', value: a.Cap },
				{ label: 'P.IVA', value: a.Vat },
				{ label: 'Cod. Fiscale', value: a.Fiscalcode },
				{ label: 'SDI', value: a.Sdi },
				{ label: 'PEC', value: a.Pec },
			].filter(riga => riga.value);
		},
		buyerName(item) {
			return [item?.buyer?.name, item?.buyer?.lastname].filter(Boolean).join(' ').trim();
		},
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				var re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},
		async propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			await this.getDataFromApi();
			this.$forceUpdate();
			this.selectedchecbox = [];
			this.operation = '';
		},
		isDarkColor(hex) {
			if (!hex || hex.length < 7) return false;
			const color = hex.replace('#', '');
			const r = parseInt(color.substr(0, 2), 16);
			const g = parseInt(color.substr(2, 2), 16);
			const b = parseInt(color.substr(4, 2), 16);
			const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
			return luminance < 140; // valore soglia per considerare un colore \"scuro\"
		},
		async creaOrdineFornitore() {
			this.dialogOrderSupplier = true;
		},
		async inviaOrdineFornitore() {
			this.dialogOrderSupplier = false;
			this.preload = true;
			this.setPreload(true);
			let orders_id = this.selectedchecbox;
			let payload = { order_date: this.dateOrderSupplier, order_ids: orders_id };
			let response = await this.createSupplierOrders(payload);

			if (response.result === true && response.all_transformed) {
				await this.fetchOrders(this.settings);
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else if (response.result === true && !response.all_transformed) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo, ma alcuni prodotti non hanno un fornitore associato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante invio in preparazione: ' + response.message;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 10000;
				this.preload = false;
				this.setPreload(false);
			}
		},
		createItem() {
			openWithReturn(this, { path: '/orders/new' }, { label: 'Torna a Fatture in Cloud' });
		},

		changeStatus(item, color) {
			let url = 'orders/updatestatus';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				if (event[0] !== -1) {
					this.selectedchecbox = [];
					_.forEach(this.getOrders, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		copy(field) {
			let input = document.createElement('input');
			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			let sc = 0;
			if (!iva || iva === 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
			}
			return sc;
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		chiediConferma(testo, azione) {
			this.conferma = { aperta: true, testo, azione };
		},
		eseguiConferma() {
			const azione = this.conferma.azione;
			this.conferma = { aperta: false, testo: '', azione: null };
			if (azione) azione();
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
			this.settings.filters.preparation_date = [];
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		editItem(key) {
			// l'ordine si apre come pagina; Annulla/Salva tornano qui
			const id = key ? key._id : this.selectedchecbox[0];
			if (id) openWithReturn(this, { path: `/orders/${id}` }, { label: 'Torna a Fatture in Cloud' });
		},
		trackingItem(key) {
			// l'ordine si apre come pagina; Annulla/Salva tornano qui
			const id = key ? key._id : this.selectedchecbox[0];
			if (id) openWithReturn(this, { path: `/orders/${id}/tracking` }, { label: 'Torna a Fatture in Cloud' });
		},
		duplicateItem(key) {
			// l'ordine si apre come pagina; Annulla/Salva tornano qui
			const id = key ? key._id : this.selectedchecbox[0];
			if (id) openWithReturn(this, { path: `/orders/${id}/duplicate` }, { label: 'Torna a Fatture in Cloud' });
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				this.settings.filters.enableAgents = false;
				//	console.log(this.settings);
				let items = this.fetchOrders(this.settings);
				items.then(result => {
					this.total = result.total;
					//this.items = result.data.data
					this.setPreload(false);
					this.selectedchecbox = [];
					this.selectedall = [];
				});
			} catch (err) {
				console.log(err);
			}
		},
		openNew() {
			openWithReturn(this, { path: '/orders/new' }, { label: 'Torna a Fatture in Cloud' });
		},
		creaCorrispettivo(key) {
			// il documento si crea in una pagina; Annulla/Salva tornano qui
			const id = key ? key._id : this.selectedchecbox[0];
			if (id) this.$router.push(`/fattureincloud/${id}/corrispettivo`);
		},
		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		creaFattura(key) {
			// il documento si crea in una pagina; Annulla/Salva tornano qui
			const id = key ? key._id : this.selectedchecbox[0];
			if (id) this.$router.push(`/fattureincloud/${id}/fattura`);
		},
		rimborsaCorrispettivo(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/rimborsaCorrispettivi';
			let payload = item;
			this.setPreload(true);
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.setPreload(false);
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;

						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		creaNotaDiCredito(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/creaNotadicredito';
			let payload = item;
			this.setPreload(true);
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.setPreload(false);
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;

						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		eliminaInvoice(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.setPreload(true);
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		eliminaCorrispettivo(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaCorrispettivi';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		async downloadReviewById() {
			this.errorDownloadReview = '';
			this.loadingDownload = true;
			let result = await this.getOrdersReview({ id_start: this.idStart, id_end: this.idEnd });
			this.loadingDownload = false;

			if (_.size(result.orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(result.orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                  if(item.kits && item.kits.length > 0){

                    textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                    _.forEach(item.kits, (kit) =>{
                      textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                    })

                  }else{

                   */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			} else {
				this.errorDownloadReview = 'Gli Id Ordini indicati non risultano corretti per individuare un range';
			}
		},

		async downloadReview() {
			let orders = _.filter(this.getOrders, o => {
				return this.selectedchecbox.includes(o._id);
			});

			if (_.size(orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                    if(item.kits && item.kits.length > 0){

                      textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                      _.forEach(item.kits, (kit) =>{
                        textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                      })

                    }else{

                     */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			}
		},
		eliminaFattura(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			let delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				let fromDate = parseInt(new Date().getTime() / 1000);
				let toDate = parseInt(new Date(delivery).getTime() / 1000);
				let timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				let box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			this.preload = true;
			let url = 'auth/delete';

			this.messages = [];

			axios
				.delete(`${this.getUrl}${url}/${this.form._id}`, { headers: { Authorization: `Bearer ${this.getToken}` } })

				.then(() => {
					const index = this.items.indexOf(this.form);
					this.items.splice(index, 1);
					this.deleteitem = '';
					this.snackbar.color = 'success';
					this.snackbar.text = 'Utente Eliminato con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					//confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
					//this.form.permission=pluck(res.data.permissions,id);
					this.preload = false;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							console.log(errors);
							errors.forEach(value => {
								console.log(value.msg);
								this.messages[value.param] = value.msg;
							});
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		getPackage(Packaging) {
			if (Packaging !== undefined) {
				return Packaging.name;
			} else {
				return 'n.d.';
			}
		},
		getPackageFromColor(color) {
			switch (color) {
				case 'grey':
					return 'n.d.';
				case 'red':
					return 1;
				case 'pink':
					return 2;
				case 'purple':
					return 3;
				case 'indigo':
					return 4;
				case 'blue':
					return 5;
				case 'green':
					return 6;
				case undefined:
					return 'n.d.';
				default:
					return 'n.d.';
			}
		},
		getPayment(payment) {
			switch (payment) {
				case 'american express':
				case 'creditcard':
				case 'maestro':
				case 'mastercard':
				case 'paypal':
				case 'visa':
					return 'Pagato';
				case 'bonifico bancario':
					return 'Bonifico';
				case 'cash on delivery (cod)':
				case 'cash on delivery cod':
				case 'cod':
					return 'Contrassegno';
				default:
					return payment;
			}
		},
		getStatusColor(statusId) {
			if (statusId && statusId._id) {
				let status = _.find(this.status, { value: statusId._id });
				return status ? status.color : '#FFFFFF';
			} else {
				return '#FFFFFF';
			}
		},
	},
	beforeDestroy() {
		this.$root.$off('updateOrdersList', this.onUpdateOrdersList);
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
.order-id-cell {
	white-space: nowrap;
	line-height: 1.35;
}
.order-cell {
	min-width: 200px;
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	line-height: 1.35;
}
.order-id,
.order-buyer {
	font-weight: 600;
}
/* Opacita' e non grigio fisso: il colore della riga arriva dallo stato ordine */
.order-label {
	font-size: 0.7rem;
	text-transform: uppercase;
	opacity: 0.65;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.fic-list-cards,
.fic-list-cards tr {
	display: block;
	width: 100%;
}
.fic-list-cards tr,
.fic-list-cards tr:hover {
	background: transparent !important;
}
.fic-list-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.fic-list-cards tr:first-child td {
	padding-top: 12px !important;
}
.fic-list-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.fic-list-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
.fic-section {
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: rgba(0, 0, 0, 0.6);
	margin-bottom: 4px;
}
.fic-line {
	background: #f7f8fa;
	border-radius: 6px;
	padding: 8px 10px;
	font-size: 14px;
	word-break: break-word;
}
.fic-line + .fic-line {
	margin-top: 6px;
}
.fic-kv {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.fic-kv span:last-child {
	color: rgba(0, 0, 0, 0.87);
	text-align: right;
	word-break: break-word;
}
</style>
